import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, IconButton } from '@material-ui/core';
import CloudDownload from '@material-ui/icons/CloudDownload';
// import { Container } from './styles';

export default function Table({ handleClick }) {
  return (
    <Tooltip title="Exporta em CSV">
      <IconButton onClick={handleClick}>
        <CloudDownload />
      </IconButton>
    </Tooltip>
  );
}

Table.propTypes = {
  handleClick: PropTypes.func.isRequired,
};
